var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "my_location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Two-Tone",
    transform: "translate(-917.000000, -3167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maps",
    transform: "translate(100.000000, 3068.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Two-Tone-/-Maps-/-my_location",
    transform: "translate(816.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3.06 C17.17,3.52 20.48,6.83 20.94,11 L23,11 L23,13 L20.94,13 C20.48,17.17 17.17,20.48 13,20.94 L13,23 L11,23 L11,20.94 C6.83,20.48 3.52,17.17 3.06,13 L1,13 L1,11 L3.06,11 C3.52,6.83 6.83,3.52 11,3.06 L11,1 L13,1 L13,3.06 Z M12,19 C15.87,19 19,15.87 19,12 C19,8.13 15.87,5 12,5 C8.13,5 5,8.13 5,12 C5,15.87 8.13,19 12,19 Z M12,8 C14.21,8 16,9.79 16,12 C16,14.21 14.21,16 12,16 C9.79,16 8,14.21 8,12 C8,9.79 9.79,8 12,8 Z M12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 Z",
    id: "\\uD83D\\uDD39-Primary-Color",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD83D\\uDD39-Secondary-Color",
    fill: "#D0D0D0",
    cx: 12,
    cy: 12,
    r: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/my-location.e78c05782a909a6345bebb9037fdfa4b.svg";
export { ForwardRef as ReactComponent };